import React from "react";
import { format } from "date-fns";
import { fullDateLongFormat } from "@common/helpers/date";
import { FiltersTypes } from "@common/types/filters/general";

interface Props {
    filters: FiltersTypes;
}

export const WorkStartDateFilterLabel: React.FC<Props> = ({ filters }) => {
    const { workStartDateStart, workStartDateEnd } = filters;

    if (!workStartDateStart && !workStartDateEnd) {
        return null;
    }

    if (workStartDateStart && workStartDateEnd) {
        return (
            <span>
                {format(workStartDateStart, fullDateLongFormat)} -{" "}
                {format(workStartDateEnd, fullDateLongFormat)}
            </span>
        );
    }

    if (workStartDateStart) {
        return (
            <span>From {format(workStartDateStart, fullDateLongFormat)}</span>
        );
    }

    if (workStartDateEnd) {
        return (
            <span>Until {format(workStartDateEnd, fullDateLongFormat)}</span>
        );
    }

    return null;
};
